export default __webpack_public_path__ + "static/media/karigar1.7e7b48c5.avif";